import Address from 'components/shared/Helpers/Address'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, formValues, initialize } from 'redux-form'
import { Button, Card, Divider, Grid } from 'semantic-ui-react'
import { FormInputDelete } from '../Forms/ReduxForm'
import AddressEditor from './AddressEditor'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      initialize,
    },
    dispatch
  )
}

class AddressList extends React.Component {
  getAddresses() {
    const {
      changeAddress, //ownProps
      initialize, //connect
      addresses = [], //formValues
    } = this.props

    const { filterText } = this.props //formValues
    let filteredAddresses = addresses.filter((address) => !address._destroy)
    if (filterText) {
      filteredAddresses = filteredAddresses.filter((address = {}) => {
        let { address1, address2, address3, place, postcode } = address
        address1 = address1 || ''
        address2 = address2 || ''
        address3 = address3 || ''
        place = place || ''
        postcode = postcode || ''
        return (
          address1.toLowerCase().includes(filterText.toLowerCase()) ||
          address2.toLowerCase().includes(filterText.toLowerCase()) ||
          address3.toLowerCase().includes(filterText.toLowerCase()) ||
          place.toLowerCase().includes(filterText.toLowerCase()) ||
          postcode.toLowerCase().includes(filterText.toLowerCase())
        )
      })
    }

    return filteredAddresses.map((address, index) => (
      <Card
        key={index}
        onClick={() => {
          initialize('address-editor', {
            index,
            ...address,
          })
        }}>
        <Card.Content extra>
          <Card.Meta>
            <Address data={address} noLinks />
          </Card.Meta>
        </Card.Content>
        <Card.Content extra>
          <Button
            icon="trash"
            secondary
            size="tiny"
            content={I18n.t('global.delete')}
            onClick={(e) => {
              e.stopPropagation()
              console.debug('AddressList::This will delete the address')
              changeAddress({ ...address, index, _destroy: true })
            }}
          />
        </Card.Content>
      </Card>
    ))
  }

  render() {
    const {
      changeAddress, //ownProps
      initialize, //connect
    } = this.props
    return (
      <div>
        <Grid stackable divided="vertically">
          <Grid.Row>
            <Grid.Column width={8}>
              <Field
                component={FormInputDelete}
                name="filterText"
                placeholder={I18n.t('global.filter')}
                width={4}
              />
              <Divider hidden />
              <Card.Group itemsPerRow={3} children={this.getAddresses()} />
            </Grid.Column>
            <Grid.Column width={4}>
              <Button
                primary
                icon="plus"
                content={I18n.t('admin.user.addresses.create')}
                onClick={() => initialize('address-editor', {})}
              />
              <AddressEditor {...{ changeAddress }} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
  }
}

AddressList = connect(mapStateToProps, mapDispatchToProps)(AddressList)
AddressList = formValues('addresses', 'filterText')(AddressList)
export default AddressList



// WEBPACK FOOTER //
// ./src/components/shared/Addresses/AddressList.jsx